/**
 * @description Hook for triggering workflows
 */

import { useMutation } from '@tanstack/react-query';
import { triggerWorkflow, BASE_URL, type TriggerWorkflowPayload } from '@/services/DataService';
import { logInfo, logger } from '@/lib/logger';



export const useTriggerWorkflow = () => {
  return useMutation({
    mutationFn: (payload: TriggerWorkflowPayload) => {
      if (!BASE_URL) {
        throw new Error('Base URL is not configured');
      }
      return triggerWorkflow(payload);
    },
    onSuccess: (data) => {
      logInfo('Workflow triggered successfully', { data });
    },
    onError: (error) => {
      logger(error as Error, { context: 'useTriggerWorkflow: Error triggering workflow' });
    },
  });
};